import { useMutation, useQueryClient } from '@tanstack/react-query';
import { custodianService, CustodianFormData } from '@/services/custodian/custodian-service';
import { custodianKeys } from '@/services/query-keys/custodian-keys';

export const useCreateCustodian = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CustodianFormData) => custodianService.createCustodian(data),
    onSuccess: () => {
      // Invalidates the register list AND the trade-entry dropdown (shared
      // `['custodians']` prefix).
      queryClient.invalidateQueries({ queryKey: custodianKeys.all });
    },
  });
};
